import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "@/hooks/useLangPath";

const Footer = () => {
  const { t } = useTranslation();
  const lp = useLangPath();

  return (
    <footer className="mt-16">
      <div className="mx-auto max-w-site px-6 py-12">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Branding */}
          <div>
            <span className="text-lg font-bold tracking-tight font-display">
              DLTDP <span className="text-gradient">Fan</span>
            </span>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-xs">
              {t("common.siteDescription")}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-2">
            <span className="text-xs font-display uppercase tracking-wider text-muted-foreground mb-1">{t("common.explore")}</span>
            <Link to={lp("/joueurs")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.players")}</Link>
            <Link to={lp("/episodes")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.episodes")}</Link>
            <Link to={lp("/tournois")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.tournaments")}</Link>
            <span className="text-sm text-muted-foreground/70 cursor-default flex items-center gap-1.5">{t("common.hands")} <span className="text-[10px] uppercase font-semibold tracking-wider bg-muted text-muted-foreground/80 px-1.5 py-0.5 rounded">{t("common.soon")}</span></span>
          </div>

          {/* À propos & Légal */}
          <div className="flex flex-col gap-2">
            <span className="text-xs font-display uppercase tracking-wider text-muted-foreground mb-1">{t("common.about")}</span>
            <Link to={lp("/la-serie")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.theSeries")}</Link>
            <Link to={lp("/mentions-legales")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.legalNotice")}</Link>
            <Link to={lp("/confidentialite")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.privacy")}</Link>
            <Link to={lp("/conditions")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.terms")}</Link>
            <Link to={lp("/contact")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">{t("common.contactUs")}</Link>
          </div>
        </div>

        <p className="mt-6 text-xs text-muted-foreground/80">
          {t("common.incorrectInfo")}{" "}
          <a href="mailto:support@dltdpfan.com" className="underline underline-offset-2 hover:text-muted-foreground transition-colors">
            {t("common.contactUs")}
          </a>
        </p>

        <div className="mt-10 pt-6 border-t border-border/50 text-center">
          <p className="text-xs text-muted-foreground/80 text-left">
            {t("common.copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
